<template>
<div>
    <!-- modal -->
    <b-modal id="patentOfficialDeadlineLogFormModal" centered size="lg" no-close-on-backdrop ref="patentOfficialDeadlineLogFormModal" :title="$t('patentOfficialDeadlineLogReport.info')" @close="clear()" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="infoRules" tag="form">
            <b-row>
                <b-col class="col-lg-12 mt-1" v-if="searchControl">
                    <b-form style="margin-top: 0.2em">
                        <validation-provider :name="$t('patentOfficialDeadlineLogReport.patent_no')" #default="{ errors }" rules="required">
                            <b-form-group :label="$t('patentOfficialDeadlineLogReport.patent_no')" label-for="patent-official-deadline-log-patent-no-input" :state="errors.length > 0 ? false : null">
                                <v-select id="patent-official-deadline-log-patent-no-input" size="sm" v-model="recordName" label="recordName" @input="setValues" @search="onFastSearch" :options="searchRecordOption.map(option => ({ ...option, recordName: option.recordName}))">
                                </v-select>
                                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12 mt-1">
                    <b-form>
                        <label for="patent-official-deadline-date-log-deadline-date">{{ $t('patentOfficialDeadlineLogReport.official_deadline_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="1" v-model="officialDeadlineDate"></CustomDatePicker>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <label for="patent-note">{{ $t('patentOfficialDeadlineLogReport.note') }}</label>
                    <b-form-textarea id="patent-note" :placeholder="$t('patentOfficialDeadlineLogReport.note')" v-model="note" rows="9" maxlength="250" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getPatentOfficialDeadlineLogList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            patentId: 0,
            officialDeadlineDate: null,
            note: '',
            searchRecordOption: [],
            searchControl: true,
            recordNo: '',
            recordName: '',
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['patentOfficialDeadlineLogFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'PatentOfficialDeadlineLog'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.note = response.data.patentOfficialDeadlineLog.note
                    this.officialDeadlineDate = response.data.patentOfficialDeadlineLog.officialDeadlineDate
                    this.patentId = response.data.patentOfficialDeadlineLog.patentId
                    this.recordNo = response.data.patentOfficialDeadlineLog.recordNo
                    this.recordName = response.data.patentOfficialDeadlineLog.recordNo
                    if (this.patentId > 0) {
                        const data = {
                            recordNo: this.recordNo,
                            isOnlyOperationRecord: true,
                            moduleId: 4
                        }

                        const controller = {
                            name: 'Module',
                            actionName: 'GetRecordListByRecordNo'
                        }
                        const payload = {
                            data: data,
                            controller: controller
                        }
                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            this.searchRecordOption = response.data.recordList
                        })
                    }
                } else {
                    this.$bvModal.hide('patentOfficialDeadlineLogFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.id = 0
            this.searchRecordOption = []
            this.officialDeadlineDate = null
            this.note = ''
            this.patentId = 0
            this.recordNo = ''
            this.recordName = ''
            this.event = null
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                patentId: this.patentId,
                note: this.note,
                officialDeadlineDate: this.officialDeadlineDate,
            }
            const controller = {
                name: 'PatentOfficialDeadlineLog'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('patentOfficialDeadlineLogFormModal')
                            this.getPatentOfficialDeadlineLogList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
        setValues(event) {
            this.patentId = event.recordId
        },
        onFastSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.findPatent(loading, search, this);
            }
        },
        findPatent(loading, search) {
            if (search.length > 2) {
                const data = {
                    recordNo: search,
                    isOnlyOperationRecord: true,
                    moduleId: 4
                }

                const controller = {
                    name: 'Module',
                    actionName: 'GetRecordListByRecordNo'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.searchRecordOption = response.data.recordList
                    loading(false)
                })
            }
        },
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
